import React from "react";
import { Wrapper } from "./SectionWrapper.styles";

const SectionWrapper = ({ children, className, bgColor, padding }) => {
  return (
    <Wrapper className={className} $bgColor={bgColor} $padding={padding}>
      {children}
    </Wrapper>
  );
};

export default SectionWrapper;
